<template>
  <div v-if="loading">
    <vpreloader width="2" size="64" />
  </div>

  <div v-else class="settings-wrapper managers-wrapper">
    <div class="settings-header">
      <h1 class="settings-title">{{ $tr('settings.title') }}</h1>

      <div class="settings-actions">
        <settings v-on="$listeners" />

        <vbutton label="settings.managers.invite" @click="displayAddUserModal = true" />
      </div>
    </div>

    <h3 class="settings-subtitle">{{ $tr('settings.users.title') }}</h3>

    <users-list :list="users" />

    <invite-modal
      v-if="displayAddUserModal"
      :is-success="isInviteModalSuccess"
      :title="$tr('admin.companies.inviteModal.userTitle')"
      @submit="inviteCompany"
      @close="toggleVisibleModal(false)"
    />
  </div>
</template>

<script>
import Axios from 'axios';
import { mapState, mapGetters, mapActions } from 'vuex';
import UsersList from '@/routes_new/inner/settings/managers/List.vue';
import InviteModal from '@/routes_new/inner/admin/components/InviteModal.vue';
import Settings from '@/routes_new/inner/settings/managers/Settings.vue';

export default {
  name: 'SettingsManagersScene',

  components: {
    Settings,
    UsersList,
    InviteModal
  },

  data() {
    return {
      displayAddUserModal: false,
      isInviteModalSuccess: false,
      loading: false
    };
  },

  computed: {
    ...mapState('user', { currentUser: 'data' }),

    ...mapState('company', ['company']),

    users() {
      let users = this.$store.getters['users/list'];

      if (!users) {
        return [];
      }

      users = this.checkLastAdmin(users);

      return users;
    }
  },

  async created() {
    this.loading = true;

    if (this.company === null) {
      await this.fetchCompany();
    }

    await this.fetchUsers();
    await this.fetchUserRoles();

    this.loading = false;
  },

  methods: {
    ...mapActions('company', { fetchCompany: 'fetch' }),

    ...mapActions('users', ['fetchUsers']),

    ...mapActions('dictionary', ['fetchUserRoles']),

    toggleVisibleModal(val) {
      this.displayAddUserModal = val;

      if (!val) {
        this.isInviteModalSuccess = false;
      }
    },

    checkLastAdmin(users) {
      let adminsCount = 0;

      users.forEach(user => {
        if (user.roles && user.roles[0] && user.roles[0].role === 'ROLE_COMPANY_ADMIN') {
          adminsCount += 1;
        }
      });

      users.map(user => {
        if (adminsCount === 1 && user.roles && user.roles[0] && user.roles[0].role === 'ROLE_COMPANY_ADMIN') {
          user.isLastAdmin = true;
        }
      });

      return users;
    },

    inviteCompany({ email, language }) {
      const userId = this.currentUser ? this.currentUser.id : null;

      if (!userId) {
        return;
      }

      Axios.post('v2/registration/invites', {
        company_id: this.company ? this.company.id : null,
        email,
        language_code: language.code,
        user_id: userId,
        type: 'join_to_company'
      })
        .then(() => {
          this.isInviteModalSuccess = true;
        })
        .catch(e => {
          let message = '';
          if (e && e.response && e.response.data && e.response.data.email) {
            message = this.$tr(`error.${Object.keys(e.response.data.email)[0]}`);
          } else {
            message = this.$tr('common.error');
          }
          this.$noty.error(message);
        });
    }
  }
};
</script>

<style lang="scss">
.settings-wrapper {
  padding-bottom: 50px;
}

.settings {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.settings-actions_managers {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.settings-actions__delete {
  display: flex;
}

.settings-actions__delete-info {
  display: flex;
  align-items: center;
  font-size: 14.3px;
  white-space: nowrap;
  color: #333;
}

.settings-navigation__button {
  width: 150px !important;
}

.controls {
  display: flex;
  align-items: center;
  justify-content: space-between;

  & .actions-block {
    position: relative;
    min-width: 300px;
  }

  & .search-input {
    width: 100%;
  }

  & .search-btn {
    color: #aaa;
    position: absolute;
    z-index: 2;
    right: 8px;
    top: calc(50% - 10px);
    cursor: pointer;
  }

  & .delete-term {
    position: relative;
    cursor: pointer;
    width: 15px;
    height: 15px;
    top: 3px;

    &:before,
    &:after {
      content: '';
      position: absolute;
      top: 6px;
      left: 0;
      display: block;
      width: 15px;
      height: 2px;
      border-radius: 2px;
      background-color: #aaa;
      transition: opacity 0.2s;
    }

    &:before {
      transform: rotate(-45deg);
    }

    &:after {
      transform: rotate(45deg);
    }
  }
}
</style>

<style lang="scss" scoped>
@import '@/styles/fonts.scss';

.settings-title {
  @include mixin-text-header-bigger;
}

.settings-subtitle {
  @include mixin-text-header-big;
  margin-bottom: 1rem;
  padding: 0;
}
/** COLUMNS */
.vcv-table .column-checkbox {
  width: 3%;
  text-align: center;
}

.vcv-table .column-avatar {
  width: 8%;
}

.vcv-table .column-vacancy {
  width: 23%;
}

.vcv-table .column-status {
  width: 13%;
}

.vcv-table .column-region {
  width: 10%;
}

/** CELLS **/

.vcv-table .vcv-table-row {
  height: 80px;
}

.vcv-table-cell {
  font-size: 16px;
}

.vcv-table-cell:nth-child(1) {
  text-align: center;
}

.vcv-table-cell .avatar {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  overflow: hidden;
}

.vcv-table-cell .avatar img {
  width: 100%;
}

.button-wrapper {
  margin-top: 25px;
}

.managers-wrapper {
  max-width: 1600px;

  .standart-navigation {
    width: 100%;
  }

  .settings-actions_managers {
    border-bottom: 1px solid #e5e5e5;
    margin-bottom: 30px;
    padding-bottom: 20px;
  }
}

.settings-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}

.settings-actions {
  display: flex;
  align-items: center;

  & > * {
    margin-right: 20px;

    &:last-child {
      margin-right: 0;
    }
  }
}
</style>
